import React, { Component } from "react";
import Grid from "../../Utils/Grid";
import { SelectField } from "../../Utils/renderField/renderField";
import { Field, reduxForm } from "redux-form";
import Title from "../../Utils/Headers/Title";
import { standardActions } from "../../Utils/Grid/StandardActions";
import { ROLE_ADMIN, ROLE_ADMIN_STATION, STATION_STATUS_IN_LIST, REGION_TYPE_IN_LIST } from "../../../../utility/constants";
import OrderSearchComponent from "../../Utils/OrderSearch/orderSearch";
import Filters from "../../Utils/Filters/Filters";
import { canCreate, canEdit, canDelete, MODULES } from "../../../../utility/permissions";
import "./stations-list.css";

class ListStation extends Component {
    componentDidMount() {
        this.props.customListStation();
        this.props.changeValueSelectStationStatus();
    }

    render() {
        const {
            customListStation,
            data,
            loader,
            onSortChange,
            eliminar_: eliminar,
            filterByStatus,
            filterByRegion,
            region,
            me, // Ensure me is destructured
        } = this.props;

        const columns = [
            {
                dataField: "no_station",
                text: "ID",
                sort: true,
                headerClasses: "text-white",
            },
            {
                dataField: "name",
                text: "Nombre",
                sort: true,
                headerClasses: "text-white",
            },
            {
                dataField: "address",
                text: "Dirección",
                sort: true,
                headerClasses: "text-white",
            },
            {
                dataField: "phone_number",
                text: "Teléfono",
                sort: true,
                headerClasses: "text-white d-none d-md-table-cell",
                classes: "d-none d-md-table-cell",
            },
            {
                dataField: "state",
                text: "Estado",
                sort: true,
                headerClasses: "text-white",
                formatter: (cell, row) => {
                    let badgeClass = "status-available";
                    let iconColor = "point-green";

                    if (row.state == 10) {
                        badgeClass = "status-available";
                        iconColor = "point-green";
                    } else if (row.state == 20) {
                        badgeClass = "status-busy";
                        iconColor = "point-orange";
                    } else if (row.state == 30) {
                        badgeClass = "status-maintenance";
                        iconColor = "point-orange-2";
                    } else if (row.state == 40) {
                        badgeClass = "status-unavailable";
                        iconColor = "point-red";
                    }

                    const statusObj = STATION_STATUS_IN_LIST.find(s => s.value === row.state);
                    const statusLabel = statusObj ? statusObj.label : cell;

                    return (
                        <div className={`status-badge ${badgeClass}`}>
                            <span className={"material-icons " + iconColor}>
                                fiber_manual_record
                            </span>
                            <span>{statusLabel}</span>
                        </div>
                    );
                },
            },
            {
                dataField: "id",
                text: "Acciones",
                headerClasses: "text-white",
                formatter: (cell, row) => {
                    const canEditPerm = canEdit(me, MODULES.STATIONS);
                    const canDeletePerm = canDelete(me, MODULES.STATIONS);

                    return (
                        <div className="action-buttons">
                            <a
                                href={`#/stations/${cell}`}
                                className="action-btn btn-view"
                                title="Ver detalles"
                            >
                                <span className="material-icons">visibility</span>
                            </a>
                            {canEditPerm && (
                                <a
                                    href={`#/stations/${cell}/editar`}
                                    className="action-btn btn-edit"
                                    title="Editar"
                                >
                                    <span className="material-icons">edit</span>
                                </a>
                            )}
                            {canDeletePerm && (
                                <button
                                    onClick={() => eliminar(cell)}
                                    className="action-btn btn-delete"
                                    title="Eliminar"
                                >
                                    <span className="material-icons">delete</span>
                                </button>
                            )}
                        </div>
                    );
                },
            },
        ];

        return (
            <div className="py-4 stations-page">
                <div className="row">
                    <div className="mb-4 col-lg-12">
                        <div className="d-flex justify-content-between align-items-center mb-4 stations-header">
                            <div>
                                <h1 className="stations-title mb-1">Estaciones</h1>
                                <p className="stations-subtitle mb-0">Listado General De Estaciones</p>
                            </div>
                            {canCreate(me, MODULES.STATIONS) && (
                                <a
                                    href="#/stations/create"
                                    className="btn btn-create-station"
                                >
                                    <i className="material-icons">add_circle</i>
                                    Crear Estación
                                </a>
                            )}
                        </div>

                        <div className="stations-filters-card">
                            <div className="row align-items-center">
                                <div className="col-lg-2 col-md-4 col-sm-12 mb-2">
                                    <div className="filter-with-icon">
                                        <span className="material-icons filter-icon">filter_alt</span>
                                        <Field
                                            name="status"
                                            placeholder={"Estado"}
                                            component={SelectField}
                                            isClearable={true}
                                            customChange={filterByStatus}
                                            options={STATION_STATUS_IN_LIST}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-2 col-md-4 col-sm-12 mb-2">
                                    <div className="filter-with-icon">
                                        <span className="material-icons filter-icon">filter_alt</span>
                                        <Filters
                                            region={{
                                                show: true,
                                                region: region,
                                                filterByRegion: filterByRegion,
                                                classNameFilter: "",
                                            }}
                                        />
                                    </div>
                                </div>

                                <OrderSearchComponent
                                    customClassSearch='w-100 justify-content-end'
                                    customClass='justify-content-end w-100 col-lg-8 col-sm-12 col-md-4'
                                    searchChange={this.props.searchCustomChange}
                                />
                            </div>
                        </div>

                        <div className="stations-table-card">
                            <div className="p-0">
                                <Grid
                                    data={data}
                                    loading={loader}
                                    columns={columns}
                                    hover={true}
                                    onPageChange={customListStation}
                                    onSortChange={onSortChange}
                                    noDataMessage={"Sin Estaciones"}
                                    tableClasses="stations-table"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: "ListStation", // a unique identifier for this form
})(ListStation);
